var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1918 16.1834C12.0334 16.1834 11.8751 16.1251 11.7501 16.0001C11.5084 15.7584 11.5084 15.3584 11.7501 15.1168L16.3668 10.5001L11.7501 5.88343C11.5084 5.64176 11.5084 5.24176 11.7501 5.0001C11.9918 4.75843 12.3918 4.75843 12.6334 5.0001L17.6918 10.0584C17.9334 10.3001 17.9334 10.7001 17.6918 10.9418L12.6334 16.0001C12.5084 16.1251 12.3501 16.1834 12.1918 16.1834Z",
    fill: "#D9DAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1085 11.125H3.0835C2.74183 11.125 2.4585 10.8417 2.4585 10.5C2.4585 10.1583 2.74183 9.875 3.0835 9.875H17.1085C17.4502 9.875 17.7335 10.1583 17.7335 10.5C17.7335 10.8417 17.4502 11.125 17.1085 11.125Z",
    fill: "#D9DAE0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.611c87f4ea4df7191bd250eef4bc890f.svg";
export { ForwardRef as ReactComponent };